import React from "react";

const SearchItemPlaceholder = () => {
  return (
    <div className="card-item">
      <div className="card-item-container">
        <div className="header">
          <div className="title">
            <div
              className="animated-background"
              style={{ height: "27px", maxWidth: "504px" }}
            />
          </div>
          {/* <div className="filing-date">Final Filing Date <time datetime="YYYY-MM-DD">MM/DD/YYYY</time></div> */}
        </div>
        <div>
          <div className="position-number">
            <div
              className="animated-background"
              style={{ height: "22px", maxWidth: "300px", marginTop: "2px" }}
            />
          </div>
          <div className="schedule">
            <div
              className="animated-background"
              style={{ height: "22px", maxWidth: "225px", marginTop: "2px" }}
            />
          </div>
          <div className="salary-range">
            <div
              className="animated-background"
              style={{ height: "22px", maxWidth: "280px", marginTop: "2px" }}
            />
          </div>
          <div className="location">
            <div
              className="animated-background"
              style={{ height: "22px", maxWidth: "260px", marginTop: "2px" }}
            />
          </div>
          <div className="location">
            <div
              className="animated-background"
              style={{ height: "22px", maxWidth: "320px", marginTop: "2px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchItemPlaceholder;
